import { render } from "./Turma.vue?vue&type=template&id=50373833&scoped=true"
import script from "./Turma.vue?vue&type=script&lang=js"
export * from "./Turma.vue?vue&type=script&lang=js"

import "./Turma.vue?vue&type=style&index=0&id=50373833&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50373833"]])

export default __exports__